import { FC } from "react";
import { Text, Textarea, Group, Button } from "@mantine/core";
import { useStyles } from "../Regtank.styles";
import {
  BUTTON_STYLES,
  BUTTON_LABELS,
  SECTION_HEADINGS,
  INSTRUCTION_TEXT,
} from "../Regtank.constants";

interface ReattemptApprovalFormProps {
  remark: string;
  onRemarkChange: (value: string) => void;
  onApprove: () => void;
  onReject: () => void;
  approveButtonDisabled: boolean;
  rejectButtonDisabled: boolean;
}

/**
 * Reusable reattempt approval form component
 * Used for both onboarding and liveness verification
 */
export const ReattemptApprovalForm: FC<ReattemptApprovalFormProps> = ({
  remark,
  onRemarkChange,
  onApprove,
  onReject,
  approveButtonDisabled,
  rejectButtonDisabled,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.div}>
      <Text className={classes.header}>{SECTION_HEADINGS.reattemptApproval}</Text>
      <Text className={classes.instruction}>
        {INSTRUCTION_TEXT.reattemptApproval}
      </Text>
      <Textarea
        value={remark}
        autosize
        minRows={2}
        maxRows={4}
        onChange={(e) => onRemarkChange(e.target.value)}
      />
      <Group mt="xl" position="left">
        <Button
          disabled={approveButtonDisabled}
          onClick={onApprove}
          style={BUTTON_STYLES.approve}
        >
          {BUTTON_LABELS.approve}
        </Button>
        <Button
          disabled={rejectButtonDisabled}
          onClick={onReject}
          style={BUTTON_STYLES.reject}
        >
          {BUTTON_LABELS.reject}
        </Button>
      </Group>
    </div>
  );
};